import styled from "styled-components";
import { PropsWithPropStyling, propStyling } from "../../../shared";

export const RootContainer = styled.div<PropsWithPropStyling>`
  all: initial;

  display: inline-flex;
  flex-direction: column;
  min-width: max-content;

  ${propStyling}
`;
